import axios from 'axios'
import { Service } from 'axios-middleware';
import RequestMiddleware from './middlewares/RequestMiddleware'
import ResponseMiddleware from "./middlewares/ResponseMiddleware";
import config from '../config'

const privateMethod = {
    getInstance() {
        const instance = axios.create({
            validateStatus: function () {
                return true;
            },
            baseURL : config.server_url
        });
        // Create a new service instance
        const service = new Service(instance);
        // Then register your middleware instances.
        service.register([
            new RequestMiddleware(),
            new ResponseMiddleware()
        ]);

        return instance;
    }
}

const Client = {

    get(resource, params) {
        return privateMethod.getInstance().get(resource, {
            params
        });
    },

    post(resource, data, headers) {
        return privateMethod.getInstance().post(resource, data, headers);
    },

    put(resource, data) {
        return privateMethod.getInstance().put(resource, data)
    },

    delete(resource) {
        return privateMethod.getInstance().delete(resource)
    },

    /**
     * Perform a custom Axios request.
     *
     * data is an object containing the following properties:
     *  - method
     *  - url
     *  - data ... request payload
     *  - auth (optional)
     *    - username
     *    - password
     **/
    customRequest(data) {
        return privateMethod.getInstance()(data)
    }
}

export default Client